var _effectorFileName = "/builds/gmini/front-common/src/components/SwitchProject/getProjectSourceTypeDesc.ts";
import { assertNever } from '@gmini/utils';
export var getProjectSourceTypeDesc = function getProjectSourceTypeDesc(sourceType) {
  switch (sourceType) {
    case 'Bim360':
      {
        return 'Bim360';
      }

    case 'GStation':
      {
        return 'G-tec';
      }

    default:
      {
        return assertNever('Unexpected sourceType', sourceType);
      }
  }
};